const env = import.meta.env;
interface Config {
  microBmsUrl?: string;
  microCopUrl?: string;
  microReportUrl?: string;
  microCciUrl?: string;
  microAmsUrl?: string;
  microCspUrl: string;
  microLspUrl: string;
  microElLsrmUrl: string;
  microLsrmUrl: string;
  microEamUrl: string;
  microNtpUrl: string;
  filePreviewUrl?: string;
  microDataReportUrl: string;
  microOmsUrl: string;
  microTmsUrl: string;
  applicationCode?: string;
  appsecret?: string;
  registerUrl?: string;
  findPasswordUrl?: string;
  reportUrl?: string;
  env?: string;
  MIDEA_AUTH?: string;
  singlePointLogin?: string;
  singlePointLogout?: string;
  singlePointURLParamsDomain?: string;
  appId?: string;
  defaultPage?: string;
  uploadAppId?: string;
  uploadAppKey?: string;
  apiUrl?: string;
  microPrivacyUrl?: string;
  bigDataLogAppName?: string;
  bigDataLogUrl?: string;
  webVersion?: string;
  webSystem?: string;
  lspChildModuleName?: string;
  lsrmChildModuleName?: string;
  otpChildModuleName?: string;
  ntpChildModuleName?: string;
  copChildModuleName?: string;
  cciChildModuleName?: string;
  amsChildModuleName?: string;
  bmsChildModuleName?: string;
  privacyChildModuleName?: string;
  reportChildModuleName?: string;
  cspChildModuleName?: string;
  eamChildModuleName?: string;
  dcChildModuleName?: string;
  workbenchUrl?: string;
  roleCode_EL_Dispatcher?: string;
  roleCode_EL_Warehouse_Admin_HQ?: string;
  roleCode_EL_Warehouse_Admin_BRANCH?: string;
  roleCode_EL_Order_Clerk?: string;
  roleCode_EL_Line_Planner?: string;
  roleCode_EL_Dispatcher_Phase_II?: string;
  roleCode_EL_Cost_Manager?: string;
  roleCode_ELS_Warehouse_Manager?: string;
  monitor_app_key: string;
}

const config: Config = {
  microLspUrl: '',
  microElLsrmUrl: '',
  microLsrmUrl: '',
  microNtpUrl: '',
  microOmsUrl: '',
  microTmsUrl: '',
  microCspUrl: '',
  microEamUrl: '',
  microDataReportUrl: '',
  bigDataLogAppName: 'C-EL',
  webVersion: '',
  webSystem: 'EL',
  otpChildModuleName: '安得数字化运营平台-调度中心',
  lspChildModuleName: '安得数字化运营平台-供应商端',
  ntpChildModuleName: '安得数字化运营平台-网络货运',
  lsrmChildModuleName: '安得数字化运营平台-供应商管理端',
  copChildModuleName: '安得数字化运营平台-安得订单门户系统',
  cciChildModuleName: '安得数字化运营平台-物流工单中台',
  amsChildModuleName: '安得数字化运营平台-物流仲裁系统',
  bmsChildModuleName: '安得数字化运营平台-计费管理系统',
  privacyChildModuleName: '安得数字化运营平台-隐私系统',
  reportChildModuleName: '安得数字化运营平台-报表查询平台',
  cspChildModuleName: '安得数字化运营平台-小安到家系统',
  eamChildModuleName: '安得数字化运营平台-企业资产管理云平台',
  dcChildModuleName: '安得数字化运营平台-数据中心',
  monitor_app_key: '',
};

if (env.VITE_ENV) {
  config.MIDEA_AUTH = env.VITE_MIDEA_AUTH;
  config.singlePointLogin = env.VITE_APP_LOGIN_URL;
  config.singlePointLogout = env.VITE_APP_LOGOUT_URL;
  config.singlePointURLParamsDomain = env.VITE_URL_PARAMS_DOMAIN;
  config.appId = env.VITE_APPID;
  config.defaultPage = env.VITE_DEFAULT_PAGE;
  config.uploadAppId = env.VITE_UPLOAD_APP_ID;
  config.uploadAppKey = env.VITE_UPLOAD_APP_KEY;
  config.apiUrl = env.VITE_API_URL;
  config.filePreviewUrl = env.VITE_File_Preview;
  config.env = env.VITE_ENV;
  config.reportUrl = env.VITE_REPORT_URL;
  config.registerUrl = env.VITE_REGISTER_URL;
  config.findPasswordUrl = env.VITE_FIND_PASSWORD_URL;
  config.appsecret = env.VITE_APPSECRET;
  config.applicationCode = env.VITE_APPLICATION_CODE;
  config.microDataReportUrl = env.VITE_APP_MICRO_DATAREPORT_URL;
  config.microOmsUrl = env.VITE_APP_MICRO_OMS_URL;
  config.microTmsUrl = env.VITE_APP_MICRO_TMS_URL;
  config.microNtpUrl = env.VITE_APP_MICRO_NTP_URL;
  config.microLsrmUrl = env.VITE_APP_MICRO_LSRM_URL;
  config.microElLsrmUrl = env.VITE_APP_MICRO_EL_LSRM_URL;
  config.microLspUrl = env.VITE_APP_MICRO_LSP_URL;
  config.microAmsUrl = env.VITE_APP_MICRO_AMS_URL;
  config.microCspUrl = env.VITE_APP_MICRO_CSP_URL;
  config.microEamUrl = env.VITE_APP_MICRO_EAM_URL;
  config.microCciUrl = env.VITE_APP_MICRO_CCI_URL;
  config.microReportUrl = env.VITE_APP_MICRO_REPORT_URL;
  config.microCopUrl = env.VITE_APP_MICRO_COP_URL;
  config.microBmsUrl = env.VITE_APP_MICRO_BMS_URL;
  config.microPrivacyUrl = env.VITE_APP_MICRO_PRIVACY_URL;
  config.bigDataLogUrl = env.VITE_APP_MICRO_BIG_DATA_LOG_URL;
  config.webVersion = env.VITE_APP_WEB_VERSION || '';
  config.workbenchUrl = env.VITE_WORKBENCH_URL;
  config.roleCode_EL_Dispatcher = env.VITE_APP_ROLE_CODE_EL_DISPATCHER;
  config.roleCode_EL_Warehouse_Admin_HQ = env.VITE_APP_ROLE_CODE_EL_WAREHOUSE_ADMIN_HQ;
  config.roleCode_EL_Warehouse_Admin_BRANCH = env.VITE_APP_ROLE_CODE_EL_WAREHOUSE_ADMIN_BRANCH;
  config.roleCode_EL_Order_Clerk = env.VITE_APP_ROLE_CODE_EL_ORDER_CLERK;
  config.roleCode_EL_Line_Planner = env.VITE_APP_ROLE_CODE_EL_LINE_PLANNER;
  config.roleCode_EL_Dispatcher_Phase_II = env.VITE_APP_ROLE_CODE_EL_DISPATCHER_PHASE_II;
  config.roleCode_EL_Cost_Manager = env.VITE_APP_ROLE_CODE_EL_COST_MANAGER;
  config.roleCode_ELS_Warehouse_Manager = env.VITE_APP_ROLE_CODE_ELS_WAREHOUSE_MANAGER;
  config.monitor_app_key = env.VITE_MONITOR_APP_KEY;
} else {
  config.MIDEA_AUTH = 'midea_auth_uat';
  config.singlePointLogin = 'https://signinuat.midea.com/login?service=';
  config.singlePointLogout = 'https://signinuat.midea.com/logout?service=';
  config.singlePointURLParamsDomain = 'annto.com';
  config.appId = 'oi4IPUjMj6Rf';
  config.defaultPage = '/index.html';
  config.uploadAppId = '32883248FE8946CCA59DDB36C80BF571';
  config.uploadAppKey = 'Vgjmcgy24Hjwb6Buq7ZfRz0uX2NebGJFrfYDRRPZ';
  config.apiUrl = '//anapi-uat.annto.com';
  config.filePreviewUrl = 'https://imipuat.midea.com/';
  config.env = 'UAT';
  config.reportUrl = 'https://lreport-uat.annto.com';
  config.registerUrl = 'https://el-uat.annto.com/lsp/lsp-register.html';
  config.findPasswordUrl = 'https://permuat.midea.com/f/find/';
  config.appsecret = '8ead982421e64bdb3e4dd5b9a14aa35cd1f19ed2';
  config.applicationCode = 'APP7961810531930112';
  config.microOmsUrl = 'https://an-uat.annto.com/otp.html';
  config.microTmsUrl = 'https://an-uat.annto.com/tms/index.html';
  config.microDataReportUrl = 'https://el-uat.annto.com/data-report/index.html';
  config.microNtpUrl = 'https://el-uat.annto.com/ntp/';
  config.microLsrmUrl = 'https://lsrm-uat.annto.com/lsrm.html';
  config.microElLsrmUrl = 'https://el-uat.annto.com/lsrm/lsrm.html';
  config.microEamUrl = 'https://ceamuat.annto.com/';
  config.microLspUrl = 'https://el-uat.annto.com/lsp/transport.html';
  config.microAmsUrl = 'https://qcs-uat.annto.com/';
  config.microCspUrl = 'https:xiaoanuat.annto.com/csp/indexcsp.html';
  config.microCciUrl = 'https://ics-uat.annto.com/index.html';
  config.microReportUrl = 'https://lreport-uat.annto.com/index.html';
  config.microCopUrl = 'https://cop-uat.annto.com/';
  config.microBmsUrl = 'https://bcp-uat.annto.com/bmsSupplier.html';
  config.microPrivacyUrl = 'https://pic-uat.annto.com/';
  config.bigDataLogUrl = 'https://apisit.midea.com/bigds/maidian';
  config.workbenchUrl = 'https://wb-uat.annto.com';
  config.roleCode_EL_Dispatcher = 'RL202411280002';
  config.roleCode_EL_Warehouse_Admin_HQ = 'RL202503120010';
  config.roleCode_EL_Warehouse_Admin_BRANCH = 'RL202503120009';
  config.roleCode_EL_Order_Clerk = 'RL202503200001';
  config.roleCode_EL_Line_Planner = 'RL202503240006';
  config.roleCode_EL_Dispatcher_Phase_II = 'RL202504160001';
  config.roleCode_EL_Cost_Manager = 'RL202506060003';
  config.roleCode_ELS_Warehouse_Manager = 'RL202507240003';
  config.monitor_app_key = 'fe8b87435f524b5b97844a78052cdb1f';
}

export default config;
